import { render, staticRenderFns } from "./FormatMenu.vue?vue&type=template&id=a0860c66&scoped=true&"
import script from "./FormatMenu.vue?vue&type=script&lang=ts&"
export * from "./FormatMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0860c66",
  null
  
)

export default component.exports